import { render } from "./Notification.vue?vue&type=template&id=2f7215eb"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=2f7215eb&lang=css"
script.render = render

export default script